import PriceCampaignCreationSecondLine from './PriceCampaignCreationSecondLine'

export default PriceCampaignCreationSecondLine
